import { Expose, Type } from 'class-transformer';
import { FileTable } from './file-table';
import { UserFileStatus } from './user-file-status';
import { RequestCriteria } from '../../shared/model/request-criteria';
import { ValueField } from 'src/app/settings/model/value-field';
import { FieldType } from 'src/app/settings/model/field-type';
import { FileType } from 'src/app/shared/model/file-type';
import { Vehicle } from 'src/app/vehicles/model/vehicle';
import { ViewState } from 'src/app/shared/model/view-state';

export class UserFile {
  @Expose({ name: 'id' })
  id: number;

  @Expose({ name: 'fileName' })
  fileName: string;

  @Expose({ name: 'fileType' })
  fileType: FileType;

  @Expose({ name: 'status' })
  status: UserFileStatus;

  @Expose({ name: 'error' })
  error: string;

  @Expose({ name: 'sourceTable' })
  sourceTable: FileTable;

  @Expose({ name: 'criteria' })
  criteria: RequestCriteria;

  @Expose({ name: 'addDate' })
  @Type(() => Date)
  addDate: Date;

  @Expose({ name: 'createdDate' })
  @Type(() => Date)
  createdDate: Date;

  @Expose({ name: 'size' })
  size: number;

  @Expose({ name: 'vehicles' })
  @Type(() => Vehicle)
  vehicles: Vehicle[];

  @Type(() => ViewState)
  viewState: ViewState;

  static getName(): string {
    return 'UserFile';
  }
}

export const userFileFields: ValueField[] = [
  Object.assign(new ValueField(), {
    name: 'id',
    type: FieldType.INTEGER,
    primaryKey: true,
    visible: false
  }),
  Object.assign(new ValueField(), {
    name: 'fileName',
    type: FieldType.TEXT,
    canFilter: true,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'size',
    type: FieldType.INTEGER,
    visible: true,
    conversion: '/1000'
  }),
  Object.assign(new ValueField(), {
    name: 'fileType',
    type: FieldType.ENUM,
    canFilter: true,
    visible: true,
    options: Object.keys(FileType).map(key => ({ key, value: FileType[key] })),
    translatable: true
  }),
  Object.assign(new ValueField(), {
    name: 'sourceTable',
    type: FieldType.ENUM,
    canFilter: true,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'status',
    type: FieldType.ENUM,
    visible: true,
    canFilter: true,
    translatable: true,
    options: [
      { key: 'NEW', value: 'filePendingToProcess' },
      { key: 'PROCESSING', value: 'fileProcessing' },
      { key: 'DONE', value: 'readyToDownload' },
      { key: 'FAILED', value: 'processingError' },
      { key: 'EXTERNAL', value: 'externalFile' },
      { key: 'ARCHIVED', value: 'archivedFile' }
    ]
  }),
  // TODO use later and pretty format criteria
  // Object.assign(new ValueField(), {
  //   name: 'criteria',
  //   type: FieldType.TEXT,
  //   visible: true
  // }),
  Object.assign(new ValueField(), {
    name: 'addDate',
    type: FieldType.DATETIME,
    canFilter: true,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'createdDate',
    type: FieldType.DATETIME,
    canFilter: true,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'error',
    type: FieldType.TEXT,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'veh_side_number',
    jsonpath: '$..[\'sideNumber\']',
    type: FieldType.ARRAY,
    visible: true,
    canFilter: true
  })
];
